import { useSyncExternalStore } from 'react'

// Tracks a CSS media query, re-rendering when it flips (a desktop window being
// resized across a breakpoint). False where matchMedia doesn't exist (tests,
// very old WebViews), which keeps the phone layout as the safe default.
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      if (typeof window === 'undefined' || !window.matchMedia) return () => {}
      const mql = window.matchMedia(query)
      mql.addEventListener?.('change', onChange)
      return () => mql.removeEventListener?.('change', onChange)
    },
    () =>
      typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(query).matches,
    () => false,
  )
}

// Wide enough to show a chat room and one of its threads side by side (Slack's
// desktop layout). Below this, a thread opens full screen over its room.
export const WIDE_LAYOUT_QUERY = '(min-width: 900px)'
